/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShowQuoteGroupResult
 */
export interface ShowQuoteGroupResult {
  /**
   *
   * @type {number}
   * @memberof ShowQuoteGroupResult
   */
  shown: number;
  /**
   *
   * @type {number}
   * @memberof ShowQuoteGroupResult
   */
  skipped: number;
}

/**
 * Check if a given object implements the ShowQuoteGroupResult interface.
 */
export function instanceOfShowQuoteGroupResult(
  value: object,
): value is ShowQuoteGroupResult {
  if (!("shown" in value) || value["shown"] === undefined) return false;
  if (!("skipped" in value) || value["skipped"] === undefined) return false;
  return true;
}

export function ShowQuoteGroupResultFromJSON(json: any): ShowQuoteGroupResult {
  return ShowQuoteGroupResultFromJSONTyped(json, false);
}

export function ShowQuoteGroupResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShowQuoteGroupResult {
  if (json == null) {
    return json;
  }
  return {
    shown: json["shown"],
    skipped: json["skipped"],
  };
}

export function ShowQuoteGroupResultToJSON(json: any): ShowQuoteGroupResult {
  return ShowQuoteGroupResultToJSONTyped(json, false);
}

export function ShowQuoteGroupResultToJSONTyped(
  value?: ShowQuoteGroupResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shown: value["shown"],
    skipped: value["skipped"],
  };
}
